import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from './messages'

export default ({ contact }) => (
  <div className="relative">
    {contact.internal && (
      <div className="absolute top-2 left-0 -mt-7 ml-8 bg-white border border-primary rounded px-2 py-1 text-xs shadow">
        <FormattedMessage {...messages.prompt}/>
      </div>
    )}

    <div className="flex items-center space-x-4">
      <img
        className="block rounded-full w-12 h-12 bg-secondary"
        src={contact?.image && contact.image.length ? contact.image : 'https://voicearchive-branding.s3.eu-central-1.amazonaws.com/avatar-fallback.jpg'}
      />

      <div>
        <div>
          <span className="font-medium text-sm">{contact.name}</span>
          {!!contact?.title?.length && (
            <span className="text-sm text-gray-700">, {contact.title}</span>
          )}
        </div>

        <div className="space-x-2">
          {contact.internal ? (
            <button className="text-sm text-primary cursor-pointer">
              <FormattedMessage {...messages.startChat}/>
            </button>
          ) : (
            <a
              className="text-sm text-primary"
              href={`mailto:${contact.email}`}
            >
              {contact.email}
            </a>
          )}

          {!!contact?.phone?.length && (
            <a className="text-sm text-gray-700" href={`tel:${contact.phone}`}>
              {contact.phone}
            </a>
          )}
        </div>
      </div>
    </div>
  </div>
)
